import { createContext } from "react";
import { useState } from "react";

const ProfessionsAndSkillsContext = createContext({
  title: '',
  description: '',
});

export const ProfessionsAndSkillsProvider = ({ children }) => {
  const [title, setTitle] = useState('');
  const [description, setDescription] = useState('');

  const titleAction = (data) => {
    setTitle(data);
  };

  const descriptionAction = (data) => {
    setDescription(data);
  };

  const resetProfessionsAndSkillsContext = () => {
    setTitle('')
    setDescription('')
  }

  return (
    <ProfessionsAndSkillsContext.Provider value={{ title, description, titleAction, descriptionAction, resetProfessionsAndSkillsContext }}>
      {children}
    </ProfessionsAndSkillsContext.Provider>
  );
};

export default ProfessionsAndSkillsContext;
